import { createMongoAbility, type MongoAbility } from "@casl/ability";
import type { AbilityRule, User } from "@/lib/api/user";
import { hasNonMentorRole } from "@/lib/utils/system-roles";

function hasScopedGroupRule(rules: AbilityRule[] | undefined): boolean {
  return (rules ?? []).some((rule) => {
    if (!rule.conditions || typeof rule.conditions !== "object") {
      return false;
    }

    const groupCondition = (
      rule.conditions as { group_id?: { $in?: unknown } }
    ).group_id;

    return Array.isArray(groupCondition?.$in) && groupCondition.$in.length > 0;
  });
}

export function hasPrivilegedAccessFromAbility(ability: MongoAbility): boolean {
  return (
    ability.can("manage", "all") ||
    hasScopedGroupRule(ability.rules as AbilityRule[])
  );
}

export function hasPrivilegedAccessFromUser(user: User | null): boolean {
  if (hasNonMentorRole(user?.systemRoles)) {
    return true;
  }

  const ability = createMongoAbility(user?.abilities ?? []);
  return hasPrivilegedAccessFromAbility(ability);
}
